import * as S from './TradingHours.styled';

const TradingHours = ({ officeHours }) => {
  if (!officeHours) return null;

  return (
    <S.TradingHours>
      <h4 className='h4-sm'>Trading Hours</h4>
      <S.TradingHoursBox>
        <div dangerouslySetInnerHTML={{ __html: officeHours }} />
      </S.TradingHoursBox>
    </S.TradingHours>
  )
}

export default TradingHours
